import { createContext, useContext, useEffect, useState } from "react";
import original from "custom/materials.json";

import { fetchMaterials, ServerMaterial } from ".";

type MaterialJson = { [key: string]: ServerMaterial };

export default function MaterialsProvider({ children }: any) {
  const [materials, setMaterials] = useState<MaterialJson>(original);

  useEffect(() => {
    let isMounted = true;

    async function fetchAndReduce() {
      const materials = await fetchMaterials();

      if (!isMounted || materials.length === 0) {
        return;
      }

      const json = materials.reduce((reduction, { id, ...rest }) => {
        reduction[id] = rest;

        return reduction;
      }, {} as MaterialJson);

      setMaterials(json);
    }

    fetchAndReduce();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <MaterialContext.Provider value={materials}>
      {children}
    </MaterialContext.Provider>
  );
}

const MaterialContext = createContext<MaterialJson>({});

export const useMaterials = () => useContext(MaterialContext);
